const PHRASES = [
  "A better way to travel",
  "Thoughtful comfort",
  "Safer journeys",
  "The little things that matter",
];

const Row = () => (
  <div className="marquee-track">
    {[0, 1].map((dup) => (
      <div key={dup} className="flex items-center" aria-hidden={dup === 1}>
        {PHRASES.map((p, i) => (
          <span key={`${dup}-${i}`} className="flex items-center">
            <span className="font-serif italic text-ivory/85 text-[34px] sm:text-[46px] lg:text-[58px] px-8">
              {p}
            </span>
            <span className="w-2 h-2 rounded-full bg-gold shrink-0" />
          </span>
        ))}
      </div>
    ))}
  </div>
);

export const Marquee = () => (
  <section
    data-testid="marquee"
    className="bg-blackk py-12 md:py-16 overflow-hidden border-y border-gold/15"
  >
    <Row />
  </section>
);
